"use client";

import { Button } from "@/components/ui/button";
import { Copy, Download } from "lucide-react";
import { toast } from "sonner";
import { useRouter } from "next/navigation";

export default function ScriptActions({
  script,
  loadstring,
}: {
  script: string;
  loadstring: string;
}) {
  const router = useRouter();

  function copyToClipboard() {
    void navigator.clipboard.writeText(script);
    return toast("Copied to clipboard!");
  }

  function downloadScript() {
    const blob = new Blob([script], { type: "text/plain" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");

    a.href = url;
    a.download = "script.lua";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);

    return toast("Downloaded script!");
  }

  function redirectToRaw() {
    try {
      if (loadstring) {
        router.push(loadstring);
      } else {
        throw new Error("Invalid loadstring format");
      }
    } catch (error) {
      console.error("Failed to redirect:", error);
    }
  }

  return (
    <>
      <Button variant="secondary" onClick={() => redirectToRaw()}>
        Raw
      </Button>
      <Button size="icon" variant="secondary" onClick={() => copyToClipboard()}>
        <Copy className="h-4 w-4" />
      </Button>
      <Button size="icon" variant="secondary" onClick={() => downloadScript()}>
        <Download className="h-4 w-4" />
      </Button>
    </>
  );
}
